module.exports = __webpack_public_path__ + "static/media/search.794c4f80.svg";